import { IInternalContactResponse } from '../../types/contacts/IInternalContact';
import { APIFactory } from '../../ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from '../../ui-toolkit/rest/axiosErrorHandler';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';
import { IParty } from '../../ui-toolkit/orders/interfaces/IParty';

export interface IUpdateParties {
  updateParties: IParty[];
  createParties: Omit<IParty, 'id'>[];
  deleteParties: IParty[];
}

//The BE ticket CC-397. This function won't work correctly without it
export const updatePartiesAsync = async ({
  orderId,
  parties,
}: {
  orderId: string;
  parties: IUpdateParties;
}): Promise<IInternalContactResponse[]> =>
  APIFactory(baseUrlService.ApiLocation)
    .put<IInternalContactResponse[]>(`/orders/v5/admin/${orderId}/parties`, parties)
    .then((response) => response.data)
    .catch(axiosErrorHandler);
